export default "__VITE_ASSET__8cf8de38__"